import {
    FETCH_RECORDING_OUTPUTS_REQUEST,
    FETCH_RECORDING_OUTPUTS_SUCCESS,
    FETCH_RECORDING_OUTPUTS_FAIL,
    GENERATE_RECORDING_OUTPUTS_REQUEST,
    GENERATE_RECORDING_OUTPUTS_SUCCESS,
    GENERATE_RECORDING_OUTPUTS_FAIL,
} from './types';

const initialState = {
    downloadRecording: {
        isLoading: false,
        isFailed: false,
    },
    generateRecording: {
        isLoading: false,
        isFailed: false,
    },
};

const reducer = (state = initialState, { type }) => {
    switch (type) {
        case FETCH_RECORDING_OUTPUTS_REQUEST:
            return {
                ...state,
                downloadRecording: {
                    ...state.downloadRecording,
                    isLoading: true,
                    isFailed: false,
                },
            };
        case FETCH_RECORDING_OUTPUTS_SUCCESS:
            return {
                ...state,
                downloadRecording: {
                    ...state.downloadRecording,
                    isLoading: false,
                    isFailed: false,
                },
            };

        case FETCH_RECORDING_OUTPUTS_FAIL:
            return {
                ...state,
                downloadRecording: {
                    ...state.downloadRecording,
                    isLoading: false,
                    isFailed: true,
                },
            };

        case GENERATE_RECORDING_OUTPUTS_REQUEST:
            return {
                ...state,
                generateRecording: {
                    ...state.generateRecording,
                    isLoading: true,
                    isFailed: false,
                },
            };

        case GENERATE_RECORDING_OUTPUTS_SUCCESS:
            return {
                ...state,
                generateRecording: {
                    ...state.generateRecording,
                    isLoading: false,
                    isFailed: false,
                },
            };

        case GENERATE_RECORDING_OUTPUTS_FAIL:
            return {
                ...state,
                generateRecording: {
                    ...state.generateRecording,
                    isLoading: false,
                    isFailed: true,
                },
            };

        default:
            return state;
    }
};

export default reducer;
